export enum RibbonTypeEnum {
  New = 'New',
  Sale = 'On Sale',
  OutOfStock = 'Out of Stock',
  FreeBundle = 'Free Bundle',
  ComingSoon = 'Coming Soon',
}

export type RibbonProduct = {
  isNewProduct?: boolean;
  discount?: number;
  isOrderable?: boolean;
  isComingSoon?: boolean;
};

export const getRibbonText = (
  { isNewProduct, discount, isOrderable, isComingSoon }: RibbonProduct,
  newText?: string,
  saleText?: string,
  outOfStockText?: string,
  comingSoonText?: string,
  vip?: boolean,
): string | null => {
  if (isComingSoon) {
    return comingSoonText || RibbonTypeEnum.ComingSoon;
  }
  if (!isOrderable && vip) {
    return outOfStockText || RibbonTypeEnum.OutOfStock;
  }
  if (discount && discount > 0 && vip === false) {
    return saleText || RibbonTypeEnum.Sale;
  }
  if (isNewProduct) {
    return newText || RibbonTypeEnum.New;
  }
  return null;
};
